export const language = {
    title: 'Change Language',
    select_laguage: 'Please select language',
    thai: 'Thai',
    english: 'English',
    dropdown: {
        th: 'ไทย',
        en: 'ENG'
    }
}
